import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { AngularMultiSelectModule } from "angular4-multiselect-dropdown/angular4-multiselect-dropdown";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { CommonModule } from "@angular/common";
import { HttpModule } from "@angular/http";
import { FileUploadModule } from "ng2-file-upload";
import { LocationStrategy, HashLocationStrategy } from "@angular/common";

import { AppComponent } from "./app.component";
import { HttpClientModule } from "@angular/common/http";

import { AppRoutingModule } from "./service/router";
import { HttpService } from "./service/http-service";
import { CommonService } from "./service/common";
import { StroageService } from "./service/stroage";
import { Login } from "./login/login.component";
import { FileUpload } from "./service/file-upload";
import { LeftMenu } from "./left-menu/leftMenu.component";
import { Index } from "./index/Index.component";
import { Banner } from "./banner/Banner.components";
import { LeadingPicture } from "./banner/leadingPicture.components";
import { DigitalSecretary } from "./task/digitalSecretary.component";
import { DigitalSecretaryEdit } from "./task/digitalSecretaryEdit.component";

import { ChallengeMission } from "./task/challengeMission.component";
import { ChallengeMissionEdit } from "./task/challengeMissionEdit.component";
import { FiveGoalTask } from "./task/fiveGoalTask.component";
import { FiveGoalTaskEdit } from "./task/fiveGoalTaskEdit.component";
import { MemberTask } from "./task/memberTask.component";
import { MemberTaskEdit } from "./task/memberTaskEdit.component";

import { SettingActivity } from "./activity/settingActivity.component";
import { SettingActivityEdit } from "./activity/settingActivityEdit.component";
import { SettingCourse } from "./activity/settingCourse.component";
import { SettingCourseEdit } from "./activity/settingCourseEdit.component";

import { EditBanner } from "./banner/BannerEdit.componen";
import { NewsCategory } from "./news/Category.component";
import { EditNewsCategory } from "./news/editCategory.component";
import { News } from "./news/news.component";
import { EditNews } from "./news/editNews.component";
import { CKEditorModule } from "ng2-ckeditor";
import { AboutUsCategory } from "./aboutUs/Category.component";
import { EditAboutUsCategory } from "./aboutUs/EditCategroy.component";
import { AboutUs } from "./aboutUs/AboutUs.component";
import { EditAboutUs } from "./aboutUs/EditAboutUs.componment";
import { EditAccount } from "./account/EditAccount.component";
import { Account } from "./account/Account.componen";
import { RepeatPasswordDirective } from "./directive/repeat-password.directive";
import { ProductBanner } from "./productBanner/banner.component";
import { EditProductBanner } from "./productBanner/ProductBannerEdit.component";
import { SettingContent } from "./settingContent/SettingContent.component";
import { EditSettingContent } from "./settingContent/EditSettingContent.component";
import { ProductGenre } from "./product/ProductGenre.componment";
import { EditProductGenre } from "./product/EditProductGenre.componment";
import { Pagination } from "./pagination/pagination.component";
import { Product } from "./product/Product.component";
import { EditProduct } from "./product/EditProduct.componment";
import { ProductRecommend } from "./product/RecommodProduct.componment";
import { DragulaModule } from "ng2-dragula";
/*import {ShareContent}                                 from "./shareContent/ShareContent.component";
import {EditShare}                                 from "./shareContent/editShare.component";*/
import { Share } from "./share/share.component";
import { ShareEdit } from "./share/shareEdit.component";

import { Notice } from "./notice/notice.component";
import { NoticeEdit } from "./notice/noticeEdit.component";
import { SystemSetting } from "./systemSetting/systemSetting.component";
import { SystemSettingEdit } from "./systemSetting/systemSettingEdit.component";
import { Version } from "./systemSetting/version.component";
import { VersionEdit } from "./systemSetting/versionEdit.component";
import { TrackingNumber } from "./trackingNumber/trackingNumber.component";
import { TrackingNumberEdit } from "./trackingNumber/trackingNumberEdit.component";
import { Address } from "./address/address.component";
import { AddressEdit } from "./address/addressEdit.component";
import { SignInTask } from "./badge/signInTask.component";
import { SignInTaskEdit } from "./badge/signInTaskEdit.component";
import { SignInHistory } from "./badge/signInHistory.component";
import { SignInHistoryEdit } from "./badge/signInHistoryEdit.component";
import { SignInTaskProduct } from "./badge/signInTaskProduct.component";
import { SignInTaskProductEdit } from "./badge/signInTaskProductEdit.component";
import { ChallengeTask } from "./badge/challengeTask.component";
import { ChallengeTaskEdit } from "./badge/challengeTaskEdit.component";
import { BadgeGit } from "./gift/badgeGit.component";
import { BadgeGitEdit } from "./gift/badgeGitEdit.component";
import { MemberGit } from "./gift/memberGit.component";
import { MemberGitEdit } from "./gift/memberGitEdit.component";
import { MemberNotify } from "./notify/memberNotify.component";
import { MemberNotifyEdit } from "./notify/memberNotifyEdit.component";
import { Sychronous } from "./notify/sychronous.component";
import { Message } from "./message/message.component";
import { MessageEdit } from "./message/messageEdit.component";
import { InformMessage } from "./message/informMessage.component";
import { InformMessageEdit } from "./message/informMessageEdit.component";
import { Film } from "./film/film.component";
import { FilmEdit } from "./film/filmEdit.component";
import { Fanstv } from "./film/fanstv.component";
import { FanstvEdit } from "./film/fanstvEdit.component";
import { FanstvPlan } from "./film/fanstvPlan.component";
import { FanstvPlanEdit } from "./film/fanstvPlanEdit.component";
import { FilmType } from "./film/filmType.component";
import { FilmTypeEdit } from "./film/filmTypeEdit.component";
import { Supplement } from "./supplement/supplement.component";
import { SupplementEdit } from "./supplement/supplementEdit.component";
import { ExperienceTaskComponent } from "./experience-task/experience-task.component";
import { ExperienceTaskEditComponent } from "./experience-task-edit/experience-task-edit.component";
import { Ng2CompleterModule } from "ng2-completer";
import { Ng2AutoCompleteModule } from "ng2-auto-complete";
import { DateTimePickerModule } from "ng-pick-datetime";
import { AppManagerComponent } from "./app-manager/app-manager.component";
import { AppManagerEditComponent } from "./app-manager-edit/app-manager-edit.component";
import { EnrollRecordListComponent } from "./enroll-record-list/enroll-record-list.component";
import { StatusPipe } from "./pipe/status.pipe";
import { EnrollRecordDetailComponent } from "./enroll-record-detail/enroll-record-detail.component";
import { NgSelectModule } from "@ng-select/ng-select";
import { GoalListComponent } from "./goal-list/goal-list.component";
import { GoalEditComponent } from "./goal-edit/goal-edit.component";
import { GoalTaskListComponent } from "./goal-task-list/goal-task-list.component";
import { GoalTaskEditComponent } from "./goal-task-edit/goal-task-edit.component";
import { LatestActivityListComponent } from "./latest-activity-list/latest-activity-list.component";
import { LatestActivityEditComponent } from "./latest-activity-edit/latest-activity-edit.component";
import { ExperienceParamsComponent } from "./experience-params/experience-params.component";
import { ExperienceParamsEditComponent } from "./experience-params-edit/experience-params-edit.component";
import { MemberDocumentComponent } from "./member-document/member-document.component";
import { GoalParamsListComponent } from "./goal-params-list/goal-params-list.component";
import { GoalParamsEditComponent } from "./goal-params-edit/goal-params-edit.component";
import { AppAccountComponent } from "./app-account/app-account.component";
import { QuestionListComponent } from './question-list/question-list.component';
import { QuestionEditComponent } from './question-edit/question-edit.component';
import { UseMethodListComponent } from './use-method-list/use-method-list.component';
import { UseMethodEditComponent } from './use-method-edit/use-method-edit.component';
import { ShareProductComponent } from './share-product/share-product.component';
import { ShareProductEditComponent } from './share-product-edit/share-product-edit.component';

import { TagInputComponent } from './service/tag-input'

@NgModule({
  declarations: [
    AppComponent,
    Login,
    Index,
    LeftMenu,
    Banner,
    LeadingPicture,
    DigitalSecretary,
    DigitalSecretaryEdit,
    ChallengeMission,
    ChallengeMissionEdit,
    FiveGoalTask,
    FiveGoalTaskEdit,
    MemberTask,
    MemberTaskEdit,
    SettingActivity,
    SettingActivityEdit,
    SettingCourse,
    SettingCourseEdit,

    EditBanner,
    NewsCategory,
    EditNewsCategory,
    News,
    EditNews,
    AboutUsCategory,
    EditAboutUsCategory,
    AboutUs,
    EditAboutUs,
    Account,
    EditAccount,
    RepeatPasswordDirective,
    ProductBanner,
    EditProductBanner,
    SettingContent,
    EditSettingContent,
    ProductGenre,
    EditProductGenre,
    Pagination,
    Product,
    EditProduct,
    ProductRecommend,
    /*  ShareContent,
    EditShare,*/
    Share,
    ShareEdit,
    Notice,
    NoticeEdit,
    SystemSetting,
    SystemSettingEdit,
    Version,
    VersionEdit,
    TrackingNumber,
    TrackingNumberEdit,
    Address,
    AddressEdit,
    SignInTask,
    SignInHistory,
    SignInHistoryEdit,
    SignInTaskEdit,
    SignInTaskProduct,
    SignInTaskProductEdit,
    ChallengeTask,
    ChallengeTaskEdit,
    BadgeGit,
    BadgeGitEdit,
    MemberGit,
    MemberGitEdit,
    MemberNotify,
    MemberNotifyEdit,
    Sychronous,
    InformMessage,
    InformMessageEdit,
    Message,
    MessageEdit,
    Film,
    FilmEdit,
    Fanstv,
    FanstvEdit,
    FanstvPlan,
    FanstvPlanEdit,
    FilmType,
    FilmTypeEdit,
    Supplement,
    SupplementEdit,
    ExperienceTaskComponent,
    ExperienceTaskEditComponent,
    AppManagerComponent,
    AppManagerEditComponent,
    EnrollRecordListComponent,
    StatusPipe,
    EnrollRecordDetailComponent,
    GoalListComponent,
    GoalEditComponent,
    GoalTaskListComponent,
    GoalTaskEditComponent,
    LatestActivityListComponent,
    LatestActivityEditComponent,
    ExperienceParamsComponent,
    ExperienceParamsEditComponent,
    MemberDocumentComponent,
    GoalParamsListComponent,
    GoalParamsEditComponent,
    AppAccountComponent,
    QuestionListComponent,
    QuestionEditComponent,
    UseMethodListComponent,
    UseMethodEditComponent,
    ShareProductComponent,
    ShareProductEditComponent,
    TagInputComponent
  ],
  imports: [
    BrowserModule,
    AngularMultiSelectModule,
    FormsModule,
    HttpModule,
    CommonModule,
    AppRoutingModule,
    FileUploadModule,
    ReactiveFormsModule,
    CKEditorModule,
    DragulaModule,
    Ng2CompleterModule,
    Ng2AutoCompleteModule,
    DateTimePickerModule,
    HttpClientModule,
    NgSelectModule,
  ],
  providers: [
    HttpService,
    CommonService,
    StroageService,
    FileUpload,
    { provide: LocationStrategy, useClass: HashLocationStrategy },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}



// WEBPACK FOOTER //
// /Users/ken/Dev/workspace/snowmantech/naturallyplus/web-cms/src/app/app.module.ts